/* eslint-disable no-shadow */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
// import EmailIcon from "@mui/icons-material/Email";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PhoneIcon from "@mui/icons-material/Phone";
// import ToggleOffIcon from "@mui/icons-material/ToggleOff";
// import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { TableCell, TableRow } from "@mui/material";
import React from "react";
// import moment from "moment";
// import tableStyle from "../../../../theme/styles/table";
// import { PERMISSIONS } from "../../../../contants";
import Typography from "../../../../components/common/new/Typography/Typography";
import Table from "../../../../components/common/new/Table/Table";
import styles from "../StructureLevelAttendanceReport/styles";
// import NewTable from "../../../member/components/Newtable/NewTable";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
  large: {
    maxWidth: "20rem",
  },
};
const FRIEND_SEAECH_TABLE_COL = [
  {
    displayName: "S.No",
    key: "s.no",
  },
  {
    displayName: "Structure Name",
    key: "strucutreName",
  },
  {
    displayName: "Coordinator Name",
    key: "coordinatorName",
  },
  {
    displayName: "Contact Number",
    key: "contactNumber",
  },
  {
    displayName: "Email Id",
    key: "emailId",
  },
];

const getRows = ({
  searchData,
  //   currentPage,
  //   pageSize,
  // initialAdvanceFormValue,
  //   onSelectMember,
  //   onSelectMemberForTransfer,
  //   hasPermission,
  // showStatusColumn,
  // onMemberStatusToggle,
  //   startDate,
  //   EndDate,
}) => {
  return searchData.map((attendanceInfo, index) => {
    return (
      <TableRow>
        <TableCell style={{ textAlign: "center" }}>
          <Typography style={styles.typoghrphyStyle}>{index + 1}</Typography>
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.large, textAlign: "center" }}>
          <Typography
            style={{
              ...styles.typoghrphyStyle,
            }}
          >
            {[
              attendanceInfo?.areaName,
              attendanceInfo?.zoneName,
              attendanceInfo?.regionName,
              attendanceInfo?.chapterName,
              attendanceInfo?.districtName,
              attendanceInfo?.blockName,
            ]
              .filter(Boolean)
              .join("/ ") || "NA"}
          </Typography>
        </TableCell>
        <TableCell style={{ textAlign: "center" }}>
          <div style={styles.tableBox}>
            <Typography style={{ ...styles.typoghrphyStyle }}>
              {attendanceInfo?.member?.fullName || "NA"}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={{ textAlign: "center" }}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {attendanceInfo?.member?.mobileNumber || "NA"}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={{ textAlign: "center" }}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {attendanceInfo?.member?.emailId || "NA"}
            </Typography>
          </div>
        </TableCell>
      </TableRow>
    );
  });
};

function ReportTable({
  searchData,
  currentPage,
  pageSize,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onSelectMember,
  hasPermission,
  showStatusColumn,
  initialAdvanceFormValue,
  appliedFilters,
}) {
  // const { monthsData } = searchData[0];
  // if (monthsData && monthsData.length > 0) {
  //   monthsData.forEach((monthInfo) => {
  //     const { monthName } = monthInfo;
  //     const monthKey = monthName.toLowerCase();

  //     if (!FRIEND_SEAECH_TABLE_COL.some((col) => col.key === monthKey)) {
  //       FRIEND_SEAECH_TABLE_COL.push({
  //         displayName: monthName,
  //         key: monthKey,
  //       });
  //     }
  //   });
  // }
  const columns = FRIEND_SEAECH_TABLE_COL;
  // const columns = showStatusColumn
  //   ? FRIEND_SEAECH_TABLE_COL
  //   : FRIEND_SEAECH_TABLE_COL.filter(
  //       (c) => c.key !== "mobile" && c.key !== "address"
  //     );

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          currentPage,
          pageSize,
          onSelectMemberForTransfer,
          onSelectMember,
          hasPermission,
          onMemberStatusToggle,
          showStatusColumn,
          initialAdvanceFormValue,
          appliedFilters,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "center",
        }}
      />
    </div>
  );
}

export default ReportTable;
